import * as defaultAppConfigValues from 'config/app.config';
import assetVersion from 'config/assetVersion.json';

const remoteConfigDefault = {
  communication_server_url: defaultAppConfigValues.HOST,
  communication_server_port: defaultAppConfigValues.PORT,
  marcus_site_url: defaultAppConfigValues.MARCUS_SITE_URL,
  appearance_json_url: defaultAppConfigValues.APPEARANCE_JSON_URL,
  addressables_catalog_base_url:
    defaultAppConfigValues.ADDRESSABLES_CATALOG_BASE_URL,
  // tutors_addressables_catalog_base_url:
  //   defaultAppConfigValues.TUTORS_ADDRESSABLES_CATALOG_BASE_URL,
  integration_keys: JSON.stringify(defaultAppConfigValues.INTEGRATION_KEYS),
  log_character_appearance: defaultAppConfigValues.LOG_CHARACTER_APPEARANCE,
  viewboard_map_image_uri: defaultAppConfigValues.VIEWBOARD_MAP_IMAGE_URI,
  viewboard_map_image_path: defaultAppConfigValues.VIEWBOARD_MAP_IMAGE_PATH,
  viewboard_share_instance_content_web_modal_margin_top:
    defaultAppConfigValues.VIEWBOARD_SHARE_INSTANCE_CONTENT_WEB_MODAL_MARGIN_TOP,
  web_scenes_version: defaultAppConfigValues.WEB_SCENES_VERSION,
  asset_version: assetVersion.assetVersion,
  bundled_levels: JSON.stringify(assetVersion.bundled),
  // Per-course/unit entry videos.
  // Matching priority:
  // 1) curriculum_id
  // 2) subject + grade
  // This list comes from the QL Alpha TikTok tracker as initial defaults.
  course_entry_videos_web: JSON.stringify([
    {
      id: 'science_3_intro',
      subject: 'Science',
      grade: '3',
      title: 'Science 3',
      description: 'Forces & Motion with Da Vinci',
      video_url: 'https://youtube.com/shorts/8mcA3RVrxuY',
    },
    {
      id: 'science_5_intro',
      subject: 'Science',
      grade: '5',
      title: 'Science 5',
      description: 'Atoms & Molecules with Marie Curie',
      video_url: 'https://youtube.com/shorts/0T_Gd1GdlaA',
    },
    {
      id: 'science_6_intro',
      subject: 'Science',
      grade: '6',
      title: 'Science 6',
      description: 'Solar System with Albert Einstein',
      video_url: 'https://youtube.com/shorts/IiBrBb5Fox0',
    },
    {
      id: 'history_3_intro',
      subject: 'History',
      grade: '3',
      title: 'History 3',
      description: 'Land Formations with Rocky',
      video_url: 'https://youtube.com/shorts/DLjtU-dR9L8',
    },
    {
      id: 'history_6_intro',
      subject: 'History',
      grade: '6',
      title: 'History 6',
      description: 'Hunters and Gatherers with Cleopatra',
      video_url: 'https://youtube.com/shorts/IksOo1qgUhE',
    },
    {
      id: 'history_7_intro',
      subject: 'History',
      grade: '7',
      title: 'History 7',
      description: 'Building the Roman Empire',
      video_url: 'https://youtube.com/shorts/8OUMw2Y7e6Q',
    },
    {
      id: 'history_8_intro',
      subject: 'History',
      grade: '8',
      title: 'History 8',
      description: 'Great Awakening with Benjamin Franklin',
      video_url: 'https://youtube.com/shorts/OQvNOE42ETs',
    },
    {
      id: 'english_2_intro',
      subject: 'English',
      grade: '2',
      title: 'English 2',
      description: 'Group Names with Mark Twain',
      video_url: 'https://youtube.com/shorts/rJx1QJjyTuw',
    },
    {
      id: 'english_3_intro',
      subject: 'English',
      grade: '3',
      title: 'English 3',
      description: 'Parts of a Sentence with Shakespeare',
      video_url: 'https://youtube.com/shorts/R2i8RegTubE',
    },
  ]),
  // Reserved for native parity (not wired yet in UI layer).
  course_entry_videos: JSON.stringify([]),
};

export default remoteConfigDefault;
